/**
 * This component currently uses hardcoded data for development purposes.
 * Once the real data is available, the hardcoded data will be replaced
 * with dynamic data to ensure proper functionality.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useConfiguration } from '../../../context/configurationContext';
import { getCloudinaryBaseUrl } from '../../../util/cloudinary';
import { findListingFieldByKey } from '../../../util/listingHelpers';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './SectionSearchByBrands.module.css';

const MAX_BRANDS = 27; // 4 rows

const SingleBrand = props => {
  const { brand } = props;
  const cloudinaryBaseUrl = getCloudinaryBaseUrl({
    variantPrefix: 'square-small',
  });
  const imagePath = `${cloudinaryBaseUrl}/listingFields/brand/${brand.option}.jpg`;
  return (
    <NamedLink
      className={css.brand}
      name="SearchPage"
      to={{
        search: `?pub_brand=${brand.option}`,
      }}
    >
      <img className={css.brandImage} src={imagePath} alt={brand.label} />
      <h4 className={css.brandTitle}>{brand.label}</h4>
    </NamedLink>
  );
};

const SectionSearchByBrands = props => {
  const { className, rootClassName } = props;

  const config = useConfiguration();
  const { listingFields } = config.listing;

  const brandField = findListingFieldByKey(listingFields, 'brand');
  const brandEnumOptions = brandField ? brandField.enumOptions : [];

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <h2 className={css.title}>
        <FormattedMessage id="LandingPage.SectionSearchByBrands.title" />
      </h2>
      <div className={css.brands}>
        {brandEnumOptions.slice(0, MAX_BRANDS).map(o => (
          <SingleBrand key={o.option} brand={o} />
        ))}
      </div>
      <NamedLink className={css.sectionLink} name="SearchBrandsPage">
        <FormattedMessage id="LandingPage.SectionSearchByBrands.browseAllLink" />
      </NamedLink>
    </div>
  );
};

const { string } = PropTypes;

SectionSearchByBrands.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionSearchByBrands.propTypes = {
  className: string,
  rootClassName: string,
};

export default SectionSearchByBrands;
